// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__SL3qP","gallery-grid":"Gallery_gallery-grid__aXh05","videoThumbnail":"Gallery_videoThumbnail__zDn3J","playIconWrapper":"Gallery_playIconWrapper___VM2x"};